import { useQuery } from '@tanstack/react-query';
import { Product } from '../domain/Products';
import { HttpProductRepository } from '../application/HttpProductRepository';

const repository = new HttpProductRepository();

export const useGetAllProducts = () => {
  return useQuery<Product[]>({
    queryKey: ['products'],
    queryFn: () => repository.getAll()
  });
};
